import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {PossessedGameAssets} from "../PossessedGameAssets";
import { gsap, TimelineLite } from 'gsap';
import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { Possessed } from "../Possessed";
import { IWinRatioConfig } from "../config/PossessedWinConfig";
import { NolimitApplication } from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import { SpineGSAPWrapper } from "../animation/SpineGSAPWrapper";

export class PossessedWinCounterView extends PIXI.Container implements StageLayer {
    // Maybe this should be handled somewhere else..
    private bgDarken:PIXI.Sprite;
    private bigWinAnimation:PIXI.spine.Spine;
    
    private winAmount:number;
    private winText:PIXI.BitmapText;    
    public fadeDuration:number = 0.1;
    
    private waysView:PIXI.Container = new PIXI.Container();
    private waysImage:PIXI.Sprite;
    private waysText:PIXI.BitmapText;

    private winCapCountUpPos:PIXI.Point = new PIXI.Point(360, 470);

    constructor() {
        super();
        this.name = "Win Counter";

        this.bgDarken = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.bgDarken.tint = 0x000000;
        this.bgDarken.anchor.set(0.5, 0.5);
        this.bgDarken.alpha = 0.7;
        this.bgDarken.visible = false;
        this.addChild(this.bgDarken);

        this.bigWinAnimation = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset(PossessedGameAssets.BIG_WIN_SPINE));
        this.bigWinAnimation.visible = false;

        this.addChild(this.bigWinAnimation);

        this.winAmount = 0;
        this.winText = new PIXI.BitmapText(`${this.winAmount}`, {
            fontName: PossessedGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 60
        });
        this.winText.alpha = 0;
        (<PIXI.Point>this.winText.anchor).set(0.5, 0.5);
        this.addChild(this.winText);

        this.waysImage = new PIXI.Sprite(Possessed.assetLoader.getTextures("Ways")[0]);
        this.waysView.addChild(this.waysImage);

        this.waysText = new PIXI.BitmapText(`${this.winAmount}`, {
            fontName: PossessedGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 40
        });
        this.waysView.addChild(this.waysText);

        this.waysView.visible = false;
        this.waysView.alpha = 0;
        this.waysView.position.set(-this.waysView.width/2, 100); 
        this.addChild(this.waysView);

        this.onResize();
    }
    
    private formatWinAmountText() {
        this.winText.scale.set(1,1);
        this.winText.text = SlotGame.apiPlugin.currency.formatValue(this.winAmount);
        if(this.winText.width > 700) {
            const newScale = 700 / this.winText.width;
            this.winText.scale.set(newScale, newScale);
        }
    }

    private updateWaysView(ways:number) {
        this.waysText.text = `${ways}`;
        if(ways == 1) 
            this.waysImage.texture = Possessed.assetLoader.getTextures("Way")[0];
        else
            this.waysImage.texture = Possessed.assetLoader.getTextures("Ways")[0];

        this.waysImage.position.set(this.waysText.width, -10);
        this.waysView.position.set(-this.waysView.width/2.0, 100);
    }

    onResize() {
        //this.position.set(360, 360);
        this.bgDarken.width = NolimitApplication.screenBounds.width;
        this.bgDarken.height = NolimitApplication.screenBounds.height;
    }

    public countUp(from:number, to:number, duration:number = 1, ways?:number):gsap.core.Timeline {
        const tl = gsap.timeline({onUpdate: () => {this.formatWinAmountText()}})
            .add(() => {
                this.winAmount = from;
                if(ways) {
                    this.waysView.visible = true;
                    this.waysText.text = `${ways}`;
                    this.updateWaysView(ways);
                }
            })
            .add(gsap.to(this.winText, {alpha: 1, duration: this.fadeDuration}))
            .add(gsap.to(this, {winAmount: to, duration: duration}), "<")
            if(ways) {
                tl.add(gsap.to(this.waysView, {alpha: 1, duration: this.fadeDuration}), "<")
            }
            return tl;
    }

    public countUpWinCap(to:number, duration:number):gsap.core.Timeline {
        const tl = gsap.timeline({
            onUpdate: () => {
                this.formatWinAmountText();
                this.position.copyFrom(this.winCapCountUpPos);
            }
        });
        tl.add(() => {
            this.winAmount = 0;
            this.winText.position.set()
        });
        tl.add(gsap.to(this.winText, {alpha: 1, duration: this.fadeDuration}));
        tl.add(gsap.to(this, {winAmount: to, duration: duration}), "<")
        return tl;
    }

    public hideWinCapCountUp(fadeDuration:number):gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(gsap.to(this.winText, {alpha: 0, duration:fadeDuration}))
        tl.add(() => {
            this.position.set(360, 360);
        })
        return tl;
    }

    public postCountUpBounce(scaleFactor:number = 1.21, posOffset:number=10) :gsap.core.Timeline {
        const duration:number = 0.11;
        const easeIn = "power3.out";
        const easeOut = "power3.in";
        const ogPos = new PIXI.Point(this.winText.position.x, this.winText.position.y);
        return gsap.timeline()
            .add(gsap.to(this.winText.position, {y: this.winText.position.y - posOffset, duration, ease: easeIn}))
            .add(gsap.to(this.winText.scale, {x: this.winText.scale.x*scaleFactor, y: this.winText.scale.y*scaleFactor, duration, ease: easeIn}), "<")
            .add(gsap.to(this.winText.position, {y: ogPos.y, duration: 0.22, ease: easeOut}))
            .add(gsap.to(this.winText.scale, {x: 1, y: 1, duration: 0.22, ease: easeOut}), "<")
    }

    public playPreBigWinWaysHighlight(ways:number):gsap.core.Timeline {
        const tl = gsap.timeline();
        this.updateWaysView(ways);
            this.waysView.position.set(-this.waysView.width/1.5, -50);
        
            tl.add(() => {
                this.waysView.visible = true;
                this.waysView.alpha = 0;
                this.waysView.scale.set(5, 5);
            });
            tl.add(gsap.to(this.waysView.scale, {x: 1.5, y: 1.5, duration: 0.1}));
            tl.add(gsap.to(this.waysView, {alpha: 1, duration:0.1}), "<")
            // Padding
            tl.add(()=>{}, ">1.5");
            
            // Remove ways view
            tl.add(() => {
                this.waysView.visible = false;
                this.waysView.alpha = 0;
                this.waysView.scale.set(1, 1);
            })
            return tl;
    }

    public playBigWinCountUp(winConf:IWinRatioConfig, from:number, to:number):gsap.core.Timeline {
        const tl = gsap.timeline();

        // Show Image and count up
        tl.add(() => {
            SpineGSAPWrapper.resetSpineState(this.bigWinAnimation);
            const animation = "L" + winConf.bigWinLevel;
            this.bigWinAnimation.alpha = 1;
            this.bigWinAnimation.state.setAnimation(0, animation, false);
            this.bgDarken.visible = true;
            this.bgDarken.alpha = 0.7;
        }, "<");

        tl.add(this.countUp(from, to, winConf.duration), "<");

        return tl;
    }


    public show(amount:number|undefined = undefined, ways?:number):gsap.core.Timeline {
        const tl = gsap.timeline()
            .add(() => {
                if(ways) {
                    this.waysText.text = `${ways}`;
                    this.waysView.visible = true;
                    this.updateWaysView(ways);
                }
                if(amount) {
                    this.winAmount = amount;
                }
                this.formatWinAmountText();
            })
            .add(gsap.to(this.winText, {alpha: 1, duration:this.fadeDuration}))
            if(ways) {
                tl.add(gsap.to(this.waysView, {alpha: 1, duration: this.fadeDuration}), "<")
            }
            return tl;
    }

    public hide():gsap.core.Timeline {
        return gsap.timeline()
            .add(gsap.to(this.waysView, {
                alpha: 0,
                duration: this.fadeDuration,
                onComplete: () => {
                    this.waysView.visible = false;
                }
            }))
            .add(gsap.to(this.winText, {
                alpha: 0,
                duration: this.fadeDuration,
            }), "<")
            .add(gsap.to(this.bigWinAnimation, {
                alpha: 0,
                duration: this.fadeDuration,
                onComplete: () => {
                    this.bigWinAnimation.visible = false;
                    this.bigWinAnimation.alpha = 1;
                }
            }), "<")
            .add(gsap.to(this.bgDarken, {
                alpha: 0,
                duration: this.fadeDuration,
                onComplete: () => {
                    this.bgDarken.visible = false;
                }
            }), "<")
    }

    public resetState() {
        this.winText.alpha = 0;
        this.waysView.alpha = 0;
        this.waysView.visible = false;
        this.winAmount = 0;
        this.position.set(360, 360);
    }
}